// Libraries
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';

import c from 'constants.js';

// CSS
import icons from './sass/icons.scss';
import fonts from './sass/fonts.scss';
import general from './sass/general.sass';

// Components
import App from './components/App.vue';

// Global Blocks
import IconGlobalBlock from './components/globalBlocks/Icon.vue';
import FixedholderGlobalBlock from './components/globalBlocks/FixedHolder.vue';

import { store } from './store';

Vue.mixin({
  created() {
    if(this.$options.block) {
      this.block = this.$options.block || '';
    }
  },
  data() {
    return {
      block: ''
    };
  }
});

Vue.config.ignoredElements = [
  'spotin-com-icon'
];

// Pull in the demo files as-is
require.context("./demo/", true, /^.*/);

Vue.component('icon-gb', IconGlobalBlock);
Vue.component('fixedholder-gb', FixedholderGlobalBlock);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuex);

const routes = [
  { path: '/:section(\\d+)?', component: App },
  { path: '/:page/:section?', component: App },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

const root = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

const app = root.$children[0];

// Need to append the invite token on routing if the page was entered using one
router.beforeEach((to, from, next) => {
  if(typeof to.query.invite === 'undefined' && app.inviteToken) {
    next({path: to.path, query: {lang: store.getters.language.code, invite: app.inviteToken}});
  } else {
    next();
  }
});




// WEBPACK FOOTER //
// ./main.js